import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();

  // If user is logged in, redirect to home page
  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  // User is not logged in, render the component
  return <>{children}</>;
};

export default ProtectedRoute;